import React, { useCallback, useMemo } from 'react';
import { Select } from 'antd';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { updateSageDefaultCostcode } from '../../../sage/state/sage.actions';
import { getCCLabel } from '../../../clock/ManualEntry/manualEntryHelpers';
import useProjectOrGlobalCostcodes from '../../../costcodes/useProjectOrGlobalCostcodes';

const labelRender = (props) => `${props.label} ${props.detailText}`;
const COSTCODE_COLUMNS = ['sageId'];

export default function SageDefaultCostcodeSelector({
  version,
  selectedIntegration,
}) {
  const dispatch = useDispatch();
  const integrations = useSelector((state) => state.sage.integrations);

  const {
    defaultCostcodeId,
    divisions = [],
  } = useMemo(() => (
    integrations.find(({ id }) => id === selectedIntegration?.id) ?? {}
  ), [selectedIntegration, integrations]);

  const { costcodes, loading } = useProjectOrGlobalCostcodes({
    projectId: null,
    divisionIds: divisions,
    visible: true,
    columns: COSTCODE_COLUMNS,
  });

  const onChange = useCallback((newSelected) => {
    if (selectedIntegration) {
      dispatch(updateSageDefaultCostcode(version, selectedIntegration.id, newSelected));
    }
  }, [selectedIntegration, version]);

  const costcodeOptions = useMemo(() => costcodes
    .filter((cc) => cc.sageId)
    .map((cc) => ({
      label: getCCLabel(cc),
      value: cc.id,
    })), [costcodes]);

  return (
    <Select
      mode="single"
      onChange={onChange}
      style={{ width: 350 }}
      value={defaultCostcodeId}
      showSearch
      optionFilterProp="label"
      options={costcodeOptions}
      loading={loading}
      labelRender={labelRender}
      allowClear
    />
  );
}

SageDefaultCostcodeSelector.propTypes = {
  version: PropTypes.string.isRequired,
  selectedIntegration: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
  }),
};

SageDefaultCostcodeSelector.defaultProps = {
  selectedIntegration: {},
};
